"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_check_circle_style_1 = __importDefault(require("./uicon.check.circle.style"));
class UiconCheckCircle extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { fillRule: "nonzero", d: "M13.651 21.47c-.208-.001-.407-.083-.555-.229l-4.469-4.482 1.108-1.096 3.916 3.951 8.602-8.795 1.12 1.097-9.156 9.361c-.15.144-.347.23-.554.241l-.012-.048zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16c-.013 8.831-7.169 15.987-16 16zm0-30.458C8.015 1.542 1.542 8.015 1.542 16S8.015 30.458 16 30.458 30.458 23.985 30.458 16 23.985 1.542 16 1.542z" }, void 0) }), void 0));
        };
    }
}
UiconCheckCircle.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconCheckCircle.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_check_circle_style_1.default)(UiconCheckCircle);
//# sourceMappingURL=uicon.check.circle.js.map